// @core/stores/userprofile/UserprofileSettingStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { userprofileApi } from '@core/api';
import type {
  GetPrivacySettingsResponse,
  GetUISettingsResponse,
  SetPrivacySettingsRequest,
  SetUISettingsRequest,
} from '@core/types/userprofile';

class UserprofileSettingStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Delete UI settings for profile
   */
  async DeleteUISettings(profile_id: string): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await userprofileApi.DeleteUISettings(profile_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get privacy settings for profile
   */
  async GetPrivacySettings(profile_id: string): Promise<GetPrivacySettingsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await userprofileApi.GetPrivacySettings(profile_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get UI settings for profile
   */
  async GetUISettings(profile_id: string): Promise<GetUISettingsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await userprofileApi.GetUISettings(profile_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Set privacy settings for profile
   */
  async SetPrivacySettings(profile_id: string, data: SetPrivacySettingsRequest): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await userprofileApi.SetPrivacySettings(profile_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Set UI settings for profile
   */
  async SetUISettings(profile_id: string, data: SetUISettingsRequest): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await userprofileApi.SetUISettings(profile_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const userprofileSettingStore = new UserprofileSettingStore();
